import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
const Tab1 = ({
  IdData,
  ModeofPayment,
  DueDateBasedOn,
  PaymentTermName,
  CreditDays,
  InvoicePortion,
  DiscountType,
  Discount,
  DiscountValidityBasedOn,
  DiscountValidity,
  Description,
}) => {
  return (
  <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>
        <div style={{ display: 'flex' }} >
          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>

                  <Input
                    id="PaymentTermName"
                    label="Payment Term Name"
                    style={{
                      height: "30px",
                      border: PaymentTermName.Error ? "1px solid red" : "",
                    }}
                    value={PaymentTermName.PaymentTermName}
                    onChange={(e) =>
                      PaymentTermName.setPaymentTermName(e.target.value)
                    }
                    readOnly
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <Input
                    id="InvoicePortion"
                    label="Invoice Portion (%)"
                    style={{
                      height: "30px",
                      border: InvoicePortion.Error ? "1px solid red" : "",
                    }}
                    value={InvoicePortion.InvoicePortion}
                    onChange={(e) => InvoicePortion.setInvoicePortion(e.target.value)}
                    readOnly
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <Input
                    label="Mode of Payment"
                    style={{
                      height: "30px",
                    }}
                    value={ModeofPayment.select_ModeofPayment}
                    readOnly
                  />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <Input
                    label="Due Date Based On"
                    style={{
                      height: "30px",
                    }}
                    value={DueDateBasedOn.DueDateBasedOn}
                    readOnly
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <Input
                    id="CreditDays"
                    label="Credit Days"
                    style={{
                      height: "30px",
                      // border: CreditDays.Error ? "1px solid red" : "",
                    }}
                    value={CreditDays.CreditDays}
                    onChange={(e) => CreditDays.setCreditDays(e.target.value)}
readOnly
                  />
                </div>
              </div>

            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Discount Settings</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>


                <div style={{ flex: 1 }}>
                   <Input
                    label="Discount Type"
                    style={{
                      height: "30px",
                    }}
                    value={DiscountType.DiscountType}
                    readOnly
                  />
                </div>

                <div style={{ flex: 1 }}>

                  <Input
                    id="Discount"
                    label="Discount"
                    style={{
                      height: "30px",
                      // border: Discount.Error ? "1px solid red" : "",
                    }}
                    value={Discount.Discount}
                    onChange={(e) => Discount.setDiscount(e.target.value)}
                    readOnly
                  />
                </div>
                {Discount.Discount !== "" && (
                  <>
                    <div style={{ flex: 1 }}>
                       <Input
                    label="Discount Validity Based On"
                    style={{
                      height: "30px",
                    }}
                    value={DiscountValidityBasedOn.DiscountValidityBasedOn}
                    readOnly
                  />
                    </div>

                  </>
                )}
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

                {Discount.Discount !== "" && (
                  <>

                    <div style={{ flex: 1 }}>
                      <Input
                        id="DiscountValidity"
                        label="Discount Validity"
                        style={{
                          height: "30px",
                          // border: Discount.Error ? "1px solid red" : "",
                        }}
                        value={DiscountValidity.DiscountValidity}
                        onChange={(e) => DiscountValidity.setDiscountValidity(e.target.value)}
                        readOnly
                      />
                    </div>
                  </>
                )}
                <div style={{ flex: 1 }}>
                  <Textarea
                    id="Description"
                    label="Description"
                    style={{
                      height: "30px",
                      border: Description.Error ? "1px solid red" : "",
                    }}
                    value={Description.Description}
                    onChange={(e) => Description.setDescription(e.target.value)}
                    readOnly
                  />
                </div>


              </div>



            </div>
          </div>
        </div>
           <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

            <div className="col-md-12 px-2">
              <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>


              <ActivityCard doctype="Payment Term" docname={IdData} />





              </div>
            </div>

          </div>
       
      </div>

    </div>
  );
};

export default Tab1;
